/* Płomyk Kasi landing v2: set + per-candle scent slots, cart drawer (set, strawberry upsell, parcel protection),
   −20% e-mail popup (customer form → code), sticky bar. Checkout = cart permalink when products are connected. */
(function () {
  var root = document.querySelector('.k'); if (!root) return;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var D = root.dataset, demo = D.demo === 'true';
  var P = { 1: +D.p1, 2: +D.p2, 3: +D.p3 }, STRAW = +D.strawPrice, PROT = parseFloat(String(D.protPrice).replace(',', '.')) || 0;
  var CODE = D.code, store = {
    get: function (k) { try { return localStorage.getItem('pk_' + k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem('pk_' + k, v); } catch (e) {} } };
  var SC = JSON.parse($('#k-scents').textContent);
  var st = { n: 2, slots: [0, 0], active: 0 };
  var cart = { set: null, straw: false, prot: D.protDefault === 'true' };

  function zl(v) { return (Math.round(v * 100) / 100).toFixed(v % 1 ? 2 : 0).replace('.', ',') + ' zł'; }
  function toast(t) { var el = $('#k-toast'); el.textContent = t; el.hidden = false; clearTimeout(el._t); el._t = setTimeout(function () { el.hidden = true; }, 3200); }
  function setImg(src) { var m = $('#k-main'); if (!src || !m) return; m.style.opacity = 0; setTimeout(function () { m.src = src; m.style.opacity = 1; }, 140);
    $$('.k-thumb').forEach(function (t) { t.classList.toggle('is-on', t.dataset.src === src); }); }

  /* ---------- buy box ---------- */
  function renderSlots() {
    var box = $('#k-slots'); box.innerHTML = '';
    st.slots.forEach(function (s, i) {
      var row = document.createElement('div'); row.className = 'k-slot' + (i === st.active ? ' is-active' : '');
      var head = '<div class="k-slot__h"><span class="k-slot__n">' + (st.n > 1 ? 'Świeca ' + (i + 1) : 'Twój zapach') + '</span><b>' + SC[s].name + '</b></div>';
      var sw = '<div class="k-sw" role="radiogroup" aria-label="Zapach świecy ' + (i + 1) + '">' + SC.map(function (x, k) {
        return '<button type="button" class="k-sw__b' + (k === s ? ' is-on' : '') + '" data-slot="' + i + '" data-k="' + k + '" role="radio" aria-checked="' + (k === s) + '" title="' + x.name + '">' +
          '<img src="' + x.thumb + '" alt=""><span>' + x.name + '</span></button>'; }).join('') + '</div>';
      row.innerHTML = head + sw; box.appendChild(row);
    });
    var distinct = st.slots.filter(function (v, i, a) { return a.indexOf(v) === i; }).length;
    $('#k-progress').textContent = st.n > 1 ? '· ' + (distinct > 1 ? distinct + ' różne zapachy' : 'wszystkie: ' + SC[st.slots[0]].name) : '';
    $('#k-same').hidden = st.n < 2; $('#k-random').textContent = st.n > 1 ? '🎲 Wybierz za mnie' : '🎲 Zaskocz mnie';
  }
  function renderPrice() {
    var p = P[st.n], full = P[1] * st.n;
    $('#k-price').textContent = zl(p);
    $('#k-was').textContent = st.n > 1 ? zl(full) : '';
    $('#k-off').textContent = st.n > 1 ? '−' + Math.round((full - p) * 100 / full) + '%' : '';
    $('#k-off').hidden = st.n < 2;
    $('#k-unit').textContent = st.n > 1 ? zl(Math.round(p / st.n)) + ' za świecę · oszczędzasz ' + zl(full - p) : 'Zestaw 2 świec taniej o ' + zl(P[1] * 2 - P[2]);
    var extra = $('#k-straw-inline').checked ? STRAW : 0;
    $('#k-buy-price').textContent = zl(p + extra);
    $('#k-sticky-name').textContent = st.n > 1 ? 'Zestaw ' + st.n + ' świec' : SC[st.slots[0]].name;
    $('#k-sticky-price').textContent = zl(p);
  }
  function renderTiers() { $$('.k-tier').forEach(function (t) { var on = +t.dataset.n === st.n; t.classList.toggle('is-on', on); t.setAttribute('aria-checked', on); }); }
  function renderBuy() { renderTiers(); renderSlots(); renderPrice(); }
  function setN(n) { n = +n; while (st.slots.length < n) st.slots.push(st.slots[st.slots.length - 1]); st.slots = st.slots.slice(0, n); st.n = n; st.active = Math.min(st.active, n - 1); renderBuy(); }

  $$('.k-tier').forEach(function (t) { t.addEventListener('click', function () { setN(t.dataset.n); }); });
  $('#k-slots').addEventListener('click', function (e) {
    var b = e.target.closest('.k-sw__b'); if (!b) return;
    var i = +b.dataset.slot, k = +b.dataset.k; st.slots[i] = k; st.active = Math.min(i + 1, st.n - 1); setImg(SC[k].img); renderSlots(); renderPrice();
  });
  $('#k-same').addEventListener('click', function () { st.slots = st.slots.map(function () { return st.slots[0]; }); renderSlots(); renderPrice(); });
  $('#k-random').addEventListener('click', function () {
    var pool = SC.map(function (_, k) { return k; }).sort(function () { return Math.random() - .5; });
    st.slots = st.slots.map(function (_, i) { return pool[i % pool.length]; }); setImg(SC[st.slots[0]].img); renderSlots(); renderPrice();
  });
  $('#k-straw-inline').addEventListener('change', renderPrice);
  $$('.k-thumb').forEach(function (t) { t.addEventListener('click', function () { setImg(t.dataset.src); }); });
  $$('[data-pick]').forEach(function (a) { a.addEventListener('click', function () { var k = +a.dataset.pick; st.slots[st.active] = k; setImg(SC[k].img); renderSlots(); renderPrice(); }); });

  /* ---------- cart drawer ---------- */
  var drawer = $('#k-drawer'), overlay = $('#k-overlay');
  function openCart() { renderCart(); drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); overlay.hidden = false; document.body.style.overflow = 'hidden'; }
  function closeCart() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); overlay.hidden = true; document.body.style.overflow = ''; }
  $$('[data-open-cart]').forEach(function (b) { b.addEventListener('click', openCart); });
  $$('[data-close-cart]').forEach(function (b) { b.addEventListener('click', closeCart); });
  overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closePop(); } });

  $('#k-buy').addEventListener('click', function () {
    cart.set = { n: st.n, slots: st.slots.slice() };
    if ($('#k-straw-inline').checked) cart.straw = true;
    openCart();
  });
  $$('[data-add-straw]').forEach(function (b) { b.addEventListener('click', function () { cart.straw = true; $('#k-straw-inline').checked = true; renderPrice(); openCart(); toast('Truskawki dodane 🍓'); }); });
  $('#k-prot').addEventListener('change', function (e) { cart.prot = e.target.checked; renderCart(); });

  function renderCart() {
    var lines = $('#k-lines'), html = '', goods = 0, was = 0;
    if (cart.set) {
      var s = cart.set, price = P[s.n], full = P[1] * s.n; goods += price; was += full;
      var names = {}; s.slots.forEach(function (k) { names[k] = (names[k] || 0) + 1; });
      html += '<div class="k-line"><img src="' + SC[s.slots[0]].thumb + '" alt=""><div><b>' + (s.n > 1 ? 'Zestaw ' + s.n + ' świec w kokosie' : 'Świeca w kokosie') + '</b>' +
        '<ul>' + Object.keys(names).map(function (k) { return '<li>' + (names[k] > 1 ? names[k] + '× ' : '') + SC[k].name + '</li>'; }).join('') + '</ul>' +
        '<button type="button" class="k-line__edit" data-edit>Zmień zapachy</button></div>' +
        '<div class="k-line__p">' + (s.n > 1 ? '<s>' + zl(full) + '</s>' : '') + '<b>' + zl(price) + '</b><button type="button" class="k-line__rm" data-rm="set" aria-label="Usuń">Usuń</button></div></div>';
    }
    if (cart.straw) {
      goods += STRAW; was += STRAW;
      html += '<div class="k-line"><img src="' + $('#k-straw-card img').src + '" alt=""><div><b>Truskawkowe świeczki w pudełku</b><ul><li>4 szt., gotowe na prezent</li></ul></div>' +
        '<div class="k-line__p"><b>' + zl(STRAW) + '</b><button type="button" class="k-line__rm" data-rm="straw" aria-label="Usuń">Usuń</button></div></div>';
    }
    lines.innerHTML = html;
    var empty = !cart.set && !cart.straw;
    $('#k-empty').hidden = !empty; $('#k-checkout').disabled = empty;
    $('#k-straw-card').hidden = cart.straw || empty;
    $('#k-prot').checked = cart.prot;
    var prot = cart.prot && !empty ? PROT : 0;
    var codeOn = store.get('code') === '1' && !empty, codeVal = codeOn ? Math.round(goods * 20) / 100 : 0;
    $('#k-sum-goods').textContent = zl(goods); $('#k-sum-was').textContent = was > goods ? zl(was) : '';
    $('#k-sum-prot-row').hidden = !prot; $('#k-sum-prot').textContent = zl(prot);
    $('#k-sum-code').hidden = !codeOn; $('#k-sum-codeval').textContent = '−' + zl(codeVal);
    $('#k-sum-total').textContent = zl(goods - codeVal + prot);
    var saved = was - goods + codeVal; $('#k-saved').textContent = saved > 0 ? 'Oszczędzasz ' + zl(saved) + ' 🎉' : '';
    var cnt = (cart.set ? cart.set.n : 0) + (cart.straw ? 1 : 0); $('#k-count').textContent = cnt; $('#k-count').hidden = !cnt;
  }
  $('#k-lines').addEventListener('click', function (e) {
    var rm = e.target.closest('[data-rm]'); if (rm) { if (rm.dataset.rm === 'set') cart.set = null; else { cart.straw = false; $('#k-straw-inline').checked = false; renderPrice(); } renderCart(); return; }
    if (e.target.closest('[data-edit]')) { closeCart(); location.hash = 'kup'; }
  });
  $('#k-checkout').addEventListener('click', function () {
    var ids = {}, ok = true;
    function add(v, q) { if (!v) { ok = false; return; } ids[v] = (ids[v] || 0) + q; }
    if (cart.set) cart.set.slots.forEach(function (k) { add(SC[k].vid, 1); });
    if (cart.straw) add(D.strawVid, 1);
    if (cart.prot) add(D.protVid, 1);
    if (demo || !ok) { toast('Sprzedaż ruszy wkrótce 🔥 To podgląd sklepu.'); return; }
    var q = Object.keys(ids).map(function (v) { return v + ':' + ids[v]; }).join(',');
    location.href = '/cart/' + q + (store.get('code') === '1' ? '?discount=' + encodeURIComponent(CODE) : '');
  });

  /* ---------- popup −20% ---------- */
  var pop = $('#k-pop'), tab = $('#k-poptab');
  function openPop() { if (store.get('code') === '1') return; pop.hidden = false; store.set('pop_seen', Date.now()); }
  function closePop() { if (pop.hidden) return; pop.hidden = true; if (store.get('code') !== '1') tab.hidden = false; }
  $$('[data-close-pop]').forEach(function (b) { b.addEventListener('click', closePop); });
  pop.addEventListener('click', function (e) { if (e.target === pop) closePop(); });
  tab.addEventListener('click', function () { tab.hidden = true; pop.hidden = false; });
  var seen = +store.get('pop_seen') || 0, claimed = store.get('code') === '1';
  if (!claimed && Date.now() - seen > 3 * 864e5) {
    setTimeout(openPop, (+root.dataset.popDelay || 9) * 1000);
    document.addEventListener('mouseout', function ex(e) { if (!e.relatedTarget && e.clientY < 5) { openPop(); document.removeEventListener('mouseout', ex); } });
  } else if (!claimed) tab.hidden = false;
  var f = $('#k-pop-f');
  if (f) f.addEventListener('submit', function (e) {
    e.preventDefault(); var btn = f.querySelector('button'); btn.disabled = true;
    fetch(f.action, { method: 'POST', body: new FormData(f), headers: { Accept: 'text/html' } })
      .then(function (r) { if (/challenge/.test(r.url)) { f.submit(); return; } done(); })
      .catch(done);
    function done() { store.set('code', '1'); $('#k-pop-form').hidden = true; $('#k-pop-done').hidden = false; tab.hidden = true; renderCart(); }
  });

  /* ---------- sticky ---------- */
  var buy = $('#kup'), sticky = $('#k-sticky');
  function stickyUpd() { if (!buy || !sticky) return; sticky.hidden = buy.getBoundingClientRect().bottom > 0 || drawer.classList.contains('is-open'); }
  window.addEventListener('scroll', stickyUpd, { passive: true }); stickyUpd();

  renderBuy(); renderCart();
})();
